<template>
	<div v-html="varhtml" />
</template>

<script>
import { getReportNanorads } from '../../services/requests/DashBoardRequests'

export default {
	data() {
		return {
			varhtml: '<p>Loading...</p>',
		}
	},

	created() {
		this.getNanoradsReport()
	},
	methods: {
		getNanoradsReport() {
			getReportNanorads().then((response) => {
				this.varhtml = response.data
			})
		},
	},
}
</script>
